import React from 'react';

const CommonLoader = () => {
    return (
        <div data-testid="common-loader" className="common-loader-wrapper">
            <div data-testid="heart-loader" className="common-heart-loader">
                <div data-testid="loading-animation" className="common-loading">
                    <svg data-testid="heart-svg" xmlSpace="preserve" viewBox="0 0 180 88" height="91px" width="180px" y="0px" x="0px" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version={1.0}>
                        <polyline
                            data-testid="heart-back-line"
                            points="0,54.583 46.217,54.583 53.514,39.989 60.811,54.583 69.325,54.583 75.406,66.746 86.351,10.8 96.080,76.475 100.946,54.583 116.756,54.583 124.055,48.503 132.568,54.583 180,54.583"
                            id="common-back"
                        />
                        <polyline
                            data-testid="heart-front-line"
                            points="0,54.583 46.217,54.583 53.514,39.989 60.811,54.583 69.325,54.583 75.406,66.746 86.351,10.8 96.080,76.475 100.946,54.583 116.756,54.583 124.055,48.503 132.568,54.583 180,54.583"
                            id="common-front"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default CommonLoader;
